<template>
    <form class="">
      <h2 class="h3">
       {{$t('ic_new_gdzie_dzis_jedziemy')}}
      </h2>
      <div class="typehead-container mb-3">
        <vue-typeahead-bootstrap
            v-model="query1"
            :data="['Warszawa','Gdańsk', 'Wałbrzych', 'Wąchock', 'Warka', 'Wałcz']"
            placeholder="Wybierz miejscowość"
            class="start no-border"
            :showOnFocus="true"
        >
          <template slot="append">
            [[%icsearch_skad? &namespace=icsearch &topic=form]]
          </template>
          <template slot="suggestion" slot-scope="{ data, htmlText }">
            <div class="d-flex align-items-center">
              <img
                  class="ms-1"
                  src="/images/pin-blue.svg"
                  style="width: 20px; height: 20px;"/>

              <span class="ms-2" v-html="htmlText"></span>
            </div>
          </template>
        </vue-typeahead-bootstrap>
        <a href="#" class="switch d-flex h-100 align-items-center"><i class="bi bi-arrow-down-up"></i></a>
      </div>
      <div class="typehead-container mb-3">
        <vue-typeahead-bootstrap
            v-model="query2"
            :data="['Warszawa','Gdańsk', 'Wałbrzych', 'Wąchock', 'Warka', 'Wałcz']"
            placeholder="Wybierz miejscowość"
            class="end no-border"
            :showOnFocus="true"
            v-reset-input=''
        >
          <template slot="append">
            [[%icsearch_dokad? &namespace=icsearch &topic=form]]
          </template>
          <template slot="suggestion" slot-scope="{ data, htmlText }">
            <div class="d-flex align-items-center">
              <img
                  class="ms-1"
                  src="/images/pin-blue.svg"
                  style="width: 20px; height: 20px;"/>
              <span class="ms-2" v-html="htmlText"></span>
            </div>
          </template>
        </vue-typeahead-bootstrap>
      </div>
      <div class="mb-3">
        <date-time></date-time>
      </div>
      <div class="mb-3">
        <div class="alert alert-warning font-size-sm" role="alert">
          <p>W pociągach PKP Intercity jednocześnie zajętych może być co najwyżej 50 proc. miejsc siedzących.</p>
          <p><a href="#">Więcej informacji na temat obowiązujących zasad w podróży</a></p>
        </div>
      </div>
      <button type="submit" class="btn btn-warning w-100  mb-2">Szukaj</button>
      <p>
        <a href="#" class="btn-link btn-adv-search">Szczegółowa wyszukiwarka połączeń</a>
      </p>
    </form>

</template>
<script>
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
import DateTime from './inputs/date-time';

import 'vue2-datepicker/index.css';

export default {
  name: 'itinerary-simple-form',
  props: {},
  components: {
    VueTypeaheadBootstrap,
    DateTime
  },
  data() {
    return {
      query1: 'Warszawa',
      query2: 'Wąchock',
    }
  },
  methods: {
    reverse() {
      let temp = this.query1;
      this.query1 = this.query2;
      this.query1 = temp;
    }
  }
}

</script>